import { EntityToUpdate } from "abstract/entity-to-update"
import { UtmBonus } from "../store"
import { apiCall } from "api-calls/api-call"

export const getUtmV2Bonuses = async(
  filter: string,
  page: number,
  limit: number,
): Promise<{
  data: UtmBonus[];
  total: number;
}> => {
  const query: { page: number; limit: number; filter?: string } = {
    page,
    limit,
  }
  if (filter) query.filter = filter

  return apiCall({
    method: "GET",
    path: "buff-play/utm-bonuses",
    query,
  })
}

export const updateUtmBonus = async(id: string, data: EntityToUpdate<UtmBonus>): Promise<void> => {
  return apiCall({
    method: "PUT",
    path: `buff-play/utm-bonuses/${id}`,
    body: data,
  })
}

export const createUtmBonus = async(data: EntityToUpdate<UtmBonus>): Promise<void> => {
  return apiCall({
    method: "POST",
    path: "buff-play/utm-bonuses",
    body: data,
  })
}
export const deleteUtmBonus = async(id: string): Promise<void> => {
  return apiCall({
    method: "DELETE",
    path: `buff-play/utm-bonuses/${id}`,
  })
}
